import toast from 'react-hot-toast'
import React from 'react'
import { AppCustomToast } from 'components/Common/AppToast'

interface ShowCustomToastOptions {
  variant?: 'success' | 'error' | 'warning' | 'info'
  title: string
  message?: string
  icon?: React.ReactNode
  actionButton?: {
    label: string
    onClick: () => void
  }
  duration?: number
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
}

export const showCustomToast = (options: ShowCustomToastOptions) => {
  const {
    variant = 'info',
    title,
    message,
    icon,
    actionButton,
    duration = 5000,
    position = 'top-right',
  } = options

  return toast.custom(
    (t) =>
      React.createElement(AppCustomToast, {
        t,
        variant,
        title,
        message,
        icon,
        actionButton,
        onDismiss: () => toast.dismiss(t.id),
      }),
    {
      duration,
      position,
    }
  )
}

// Convenience methods for different variants
export const showSuccessToast = (
  title: string,
  message?: string,
  options?: Partial<ShowCustomToastOptions>
) => {
  return showCustomToast({ ...options, variant: 'success', title, message })
}

export const showErrorToast = (
  title: string,
  message?: string,
  options?: Partial<ShowCustomToastOptions>
) => {
  return showCustomToast({ ...options, variant: 'error', title, message })
}

export const showWarningToast = (
  title: string,
  message?: string,
  options?: Partial<ShowCustomToastOptions>
) => {
  return showCustomToast({ ...options, variant: 'warning', title, message })
}

export const showInfoToast = (
  title: string,
  message?: string,
  options?: Partial<ShowCustomToastOptions>
) => {
  return showCustomToast({ ...options, variant: 'info', title, message })
}
